/* Theme-wide cart helpers, loaded on every page that uses layout/theme.liquid. */
(() => {
const eoCartRoot = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';

function eoCartSectionIds(drawer) {
  return drawer && typeof drawer.getSectionsToRender === 'function'
    ? drawer.getSectionsToRender().map((s) => s.id)
    : ['cart-drawer', 'cart-icon-bubble'];
}

/* Re-render the cart drawer and header bubble from the server's current cart without opening
   the drawer. Used after a back/forward-cache restore, where the page shows the cart as it was
   when the customer left (e.g. before an LP "Add to cart" sent them to checkout). */
async function eoRefreshCart() {
  const drawer = document.querySelector('cart-drawer');
  const ids = eoCartSectionIds(drawer);
  const [cartRes, sectionsRes] = await Promise.all([
    fetch(`${eoCartRoot}cart.js`, { headers: { Accept: 'application/json' }, cache: 'no-store' }),
    fetch(`${window.location.pathname}?sections=${encodeURIComponent(ids.join(','))}`, { cache: 'no-store' }),
  ]);
  if (!cartRes.ok || !sectionsRes.ok) throw new Error(`cart refresh failed (${cartRes.status}/${sectionsRes.status})`);
  const state = await cartRes.json();
  state.sections = await sectionsRes.json();

  if (drawer && typeof drawer.renderContents === 'function') {
    const wasOpen = drawer.classList.contains('active');
    drawer.classList.toggle('is-empty', state.item_count === 0);
    drawer.renderContents(state, true); // second argument: do not open the drawer
    // Guard against a runtime whose renderContents ignores that flag: a refresh must never pop the drawer open.
    if (!wasOpen) setTimeout(() => { if (drawer.classList.contains('active') && typeof drawer.close === 'function') drawer.close(); });
    return state;
  }

  // No drawer component: swap the rendered sections in place.
  ids.forEach((id) => {
    const target = document.getElementById(id) || document.getElementById(`shopify-section-${id}`);
    const html = state.sections[id];
    if (!target || !html) return;
    const fresh = new DOMParser().parseFromString(html, 'text/html').querySelector('.shopify-section');
    if (fresh) target.innerHTML = fresh.innerHTML;
  });
  return state;
}
window.eoRefreshCart = eoRefreshCart;

window.addEventListener('pageshow', (event) => {
  if (!event.persisted) return;
  eoRefreshCart().catch((error) => console.error('Cart refresh:', error));
});

/* Cart drawer upsell: adds one more pack bought the same way as the line it upsells (the snippet
   only sets data-plan when that line is on a selling plan) and re-renders the drawer through the
   theme's own section rendering. */
document.addEventListener('click', async (event) => {
  const button = event.target.closest('[data-eo-upsell]');
  if (!button || button.disabled) return;
  const drawer = document.querySelector('cart-drawer');
  button.disabled = true;
  button.classList.add('is-loading');
  const item = { id: Number(button.dataset.variant), quantity: 1 };
  if (button.dataset.plan) item.selling_plan = Number(button.dataset.plan);
  const sections = eoCartSectionIds(drawer);
  try {
    const res = await fetch(`${(window.routes && window.routes.cart_add_url) || '/cart/add'}.js`, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ items: [item], sections, sections_url: window.location.pathname }),
    });
    const state = await res.json().catch(() => ({ description: `HTTP ${res.status}` }));
    if (!res.ok || state.status) throw new Error(state.description || 'add failed');
    if (drawer && typeof drawer.renderContents === 'function') drawer.renderContents(state);
    else window.location.reload();
  } catch (error) {
    console.error('Cart upsell:', error);
    button.disabled = false;
    button.classList.remove('is-loading');
  }
});
})();
